const LAYOUT_MAP_URL =
  "https://customer-assets.emergentagent.com/job_expert-info-days/artifacts/tj8ebz0e_solar%20farm%20layout.png";

export default function IndicativeLayout() {
  return (
    <section id="layout" className="bg-[#F9F8F6]" data-testid="indicative-layout-section">
      <div className="mx-auto max-w-7xl px-6 lg:px-10 py-20 lg:py-28">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 mb-12">
          <div className="lg:col-span-5 reveal">
            <p className="overline mb-4">Indicative layout</p>
            <h2 className="font-serif-display text-3xl lg:text-4xl tracking-tight">
              How the solar arrays sit within the existing field pattern.
            </h2>
          </div>
          <div className="lg:col-span-6 lg:col-start-7 reveal">
            <p className="text-[15px] leading-relaxed text-[#2A2B2A]/85">
              The aerial overlay below shows our current indicative layout. The
              solar arrays (in blue) follow the existing field boundaries
              wherever possible — leaving hedgerows, mature trees and sensitive
              habitats untouched. Site entrances, the sub-station and the grid
              connection are labelled directly on the map.
            </p>
          </div>
        </div>

        <figure className="reveal rounded-sm border border-[#E0DCD3] bg-white overflow-hidden">
          <a
            href={LAYOUT_MAP_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="layout-map-link"
            className="block group"
            aria-label="Open full-size site layout map in a new tab"
          >
            <img
              src={LAYOUT_MAP_URL}
              alt="Aerial satellite map of the Loughrea Solar Farm site showing the indicative solar array layout in blue, with labelled site entrances, sub-station, temporary compounds and grid connection annotations"
              className="block w-full h-auto transition-transform duration-700 group-hover:scale-[1.01]"
              loading="lazy"
            />
          </a>
          <figcaption className="border-t border-[#E0DCD3] bg-[#F9F8F6] px-5 py-3 flex flex-wrap items-center gap-x-6 gap-y-1 text-[11px] text-[#63635E]">
            <span className="text-[#4C4538] font-semibold tracking-[0.16em] uppercase">
              Indicative site layout · aerial basemap
            </span>
            <span className="ml-auto italic">Tap to view full size · subject to refinement</span>
          </figcaption>
        </figure>
      </div>
    </section>
  );
}
